import request from '@/shared/api/request';

/**
 *
 * Resend verification email with the link.
 *
 * @returns {Promise}
 */
export const resendVerificationEmail = (): Promise<{ message: string }> =>
  request({
    url: '/account/register/verification_email/',
    method: 'POST',
  });
